import { useEffect } from 'react'
import { ILayout, useLayout } from '../../core'

const Footer = () => {
  const { config } = useLayout()
  useEffect(() => {
    updateDOM(config)
  }, [config])

  return (
    <>
      <div className='text-gray-900 order-2 order-md-1'>
        <span className='text-muted fw-semibold me-1'>
          {new Date().getFullYear().toString()}&copy;
        </span>
        {/* <a
          href={import.meta.env.VITE_TRENDCOMMERCE_URL}
          target='_blank'
          rel='noopener noreferrer'
          className='text-gray-800 text-hover-primary'
        >
          SPS
        </a> */}
        <span className='text-muted fw-semibold me-1'>
          SPS
        </span>
      </div>

      {/* <ul className='menu menu-gray-600 menu-hover-primary fw-semibold order-1'>
        <li className='menu-item'>
          <a
            href={import.meta.env.VITE_TRENDCOMMERCE_TCGATE_URL}
            target='_blank'
            rel='noopener noreferrer'
            className='menu-link px-2'>
          </a>
        </li>
      </ul> */}

      <ul className='menu fw-semibold order-1'>
        <li className='menu-item'>
          <span className='text-muted px-2'>
            TC.gate {import.meta.env.VITE_TCGATE_VERSION}
          </span>
        </li>

      </ul>
    </>
  )
}

const updateDOM = (config: ILayout) => {
  if (config.app?.footer?.fixed?.desktop) {
    document.body.classList.add('data-kt-app-footer-fixed', 'true')
  }

  if (config.app?.footer?.fixed?.mobile) {
    document.body.classList.add('data-kt-app-footer-fixed-mobile', 'true')
  }
}

export { Footer }
